import { keyframes } from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
/**
 * Animation for sliding an element into the viewport from the right.
 */


var slideInFromRight = function slideInFromRight() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$from = _ref.from,
      from = _ref$from === void 0 ? '100%' : _ref$from,
      _ref$to = _ref.to,
      to = _ref$to === void 0 ? '0' : _ref$to;

  return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: translateX(", ");\n  }\n\n  to {\n    transform: translateX(", ");\n  }\n"])), from, to);
};
/**
 * Animation for sliding an element into the viewport from the left.
 */


var slideInFromLeft = function slideInFromLeft(direction) {
  return keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from {\n    transform: translateX(-100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n"])));
};
/**
 * Animation for sliding an element into the viewport from the top.
 */


var slideInFromTop = function slideInFromTop(direction) {
  return keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(-100%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n"])));
};
/**
 * Animation for sliding an element into the viewport from the bottom.
 */


var slideInFromBottom = function slideInFromBottom() {
  return keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(100%);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n"])));
};
/**
 * Animation for sliding an element out of the viewport to the right.
 */


var slideOutToRight = function slideOutToRight() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$from = _ref2.from,
      from = _ref2$from === void 0 ? '0' : _ref2$from,
      _ref2$to = _ref2.to,
      to = _ref2$to === void 0 ? '100%' : _ref2$to;

  return keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  from {\n    transform: translateX(", ");\n  }\n\n  to {\n    transform: translateX(", ");\n  }\n"])), from, to);
};
/**
 * Animation for sliding an element out of the viewport to the left.
 */


var slideOutToLeft = function slideOutToLeft(direction) {
  return keyframes(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(-100%);\n  }\n"])));
};
/**
 * Animation for sliding an element out of the viewport to the top.
 */


var slideOutToTop = function slideOutToTop(direction) {
  return keyframes(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(0);\n  }\n\n  to {\n    transform: translateY(-100%);\n  }\n"])));
};
/**
 * Animation for sliding an element out of the viewport to the bottom.
 */


var slideOutToBottom = function slideOutToBottom() {
  return keyframes(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(0);\n  }\n\n  to {\n    transform: translateY(100%);\n  }\n"])));
};
/**
 * Helper for common animation action of animating a new image
 * into the viewport while at the same time animating the current
 * image out of the viewport in, e.g., an image carousel.
 *
 * General usage would be to call this helper twice for a single composite animation.
 * Once for the image being slid out, and a second time for the image being slid in.
 *
 * @param animateDirection - direction of the composite animation. One of: previous|next.
 * @param isCurrentImage - whether or not this is the current image that should be animated in.
 */


function getSlideAnimation(_ref3) {
  var animateDirection = _ref3.animateDirection,
      isCurrentImage = _ref3.isCurrentImage;

  if (animateDirection === 'next') {
    return isCurrentImage ? slideInFromRight : slideOutToLeft;
  } else if (animateDirection === 'previous') {
    return isCurrentImage ? slideInFromLeft : slideOutToRight;
  } else {
    return null; // no animation
  }
}

export { getSlideAnimation, slideInFromBottom, slideInFromLeft, slideInFromRight, slideInFromTop, slideOutToBottom, slideOutToLeft, slideOutToRight, slideOutToTop };